export const FIRST_PRESENT_ACCOUNT_STATUS = 'Account_Status';

export const FIRST_PRESENT_LAST_READ_TIME = 'last_read_time';
